import React from 'react';
import PropTypes from 'prop-types';
import { Heading_1 as Heading1, PrimaryButton } from '@huggg/react-components';
import dictionary from 'config/dictionary';
import BackButton from '../../BackButton/BackButton';
import styles from '../bankPaymentRedemption.module.scss';

export const RetryView = ({ onRetry, isLoading, error }) => (
  <div className={styles.container} data-test-id="bank-payment-retry-view">
    <div className={styles.header}>
      <Heading1>{dictionary.bankPayment.labels.retryTitle}</Heading1>
    </div>
    <p className={styles.body}>{dictionary.bankPayment.copy.retryBody}</p>
    {error && (
      <p className={styles.error} data-test-id="bank-payment-retry-error">
        {dictionary.bankPayment.errors.initiateFailed}
      </p>
    )}
    <div className={styles.ctaWrapper}>
      <PrimaryButton
        onClick={onRetry}
        label={
          isLoading
            ? dictionary.bankPayment.labels.connectingCta
            : dictionary.bankPayment.labels.differentBankCta
        }
        disabled={isLoading}
        className={styles.cta}
        data-test-id="bank-payment-retry-cta"
      />
    </div>
    <BackButton className={styles.backButton} />
  </div>
);

RetryView.propTypes = {
  onRetry: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  error: PropTypes.any
};

export default RetryView;
